/**
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 * Sectors - Kabatwa 
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 */
module.exports = {
  "Batikoti": ["Batikoti", "Kamuhe", "Rubare", "Sake"],
  "Cyamvumba": ["Kabagabo", "Murambi", "Nyabitembo"],
  "Gihorwe": ["Bisukiro", "Kaminuza", "Kinyababa", "Rushubi"],
  "Myuga": ["Akabeza", "Akimitoni", "Butaka", "Myuga", "Rugendabari"],
  "Ngando": ["Gaharawe", "Kiramira", "Mahurura", "Ngando", "Ruhango"],
  "Rugarama": ["Karambi", "Kinkware", "Masasa", "Rebero", "Remera"]
};